module.exports = __webpack_public_path__ + "86676470228265bf24e96c10373f5406.png";